import { drawSymbol } from '../../common/utils/helper';
import { PathOption, Size } from '@syncfusion/ej2-svg-base';
import { Browser, extend, remove, isNullOrUndefined, Animation } from '@syncfusion/ej2-base';
import { ChartData } from '../../chart/utils/get-data';
import { withInBounds, PointData, stopTimer, getElement } from '../../common/utils/helper';
import { colorNameToHex, convertHexToColor } from '../../common/utils/helper';
/**
 * The `Marker` module is used to render markers for line-type series.
 *
 * @private
 */
export class MarkerExplode extends ChartData {
    /**
     * Constructor for the marker module.
     *
     * @private
     */
    constructor(chart) {
        super(chart);
        this.elementId = chart.element.id;
        this.commonXvalues = [];
    }
    /**
     * Adds event listeners for the series.
     *
     * @returns {void}
     * @private
     */
    addEventListener() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.on(Browser.touchMoveEvent, this.mouseMoveHandler, this);
        this.chart.on(Browser.touchEndEvent, this.mouseUpHandler, this);
    }
    /**
     * Removes event listeners for the series.
     *
     * @private
     *
     * @returns {void}
     */
    removeEventListener() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.off(Browser.touchMoveEvent, this.mouseMoveHandler);
        this.chart.off(Browser.touchEndEvent, this.mouseUpHandler);
    }
    /**
     * Handles the mouse up event.
     *
     * @returns {void}
     */
    mouseUpHandler() {
        const chart = this.chart;
        if (chart.isTouch && !chart.crosshair.enable && !this.isSelected(chart) && !(this.chart.zoomModule && getElement(this.elementId + '_ZoomArea'))) {
            this.markerMove(true);
        }
    }
    /**
     * Handles the mouse move event.
     *
     * @returns {void}
     * @private
     */
    mouseMoveHandler() {
        const chart = this.chart;
        if ((chart.highlightMode !== 'None' || (chart.tooltip.enable)) && (!chart.isTouch || chart.startMove) && !this.isSelected(chart)
            && !(this.chart.zoomModule && (getElement(this.elementId + '_ZoomArea') || this.chart.zoomModule.startPanning))) {
            this.markerMove(false);
        }
    }
    markerMove(remove) {
        const chart = this.chart;
        this.currentPoints = [];
        let data;
        let previous;
        let explodeSeries;
        let series;
        if ((!chart.tooltip.shared && !chart.tooltip.split) || !chart.tooltip.enable) {
            data = this.getData();
            series = data.series;
            previous = this.previousPoints[0];
            explodeSeries = series && ((series.type === 'Bubble' || series.drawType === 'Scatter' || series.type === 'Scatter') ||
                (((series.type !== 'Candle') && (series.type !== 'Hilo') && (series.type !== 'HiloOpenClose')) &&
                    (series.marker.visible && series.marker.width !== 0 && series.marker.height !== 0)));
            data.lierIndex = this.lierIndex;
            if (data.point && explodeSeries && ((!previous || (previous.point !== data.point)) ||
                (previous && previous.lierIndex > 3 && previous.lierIndex !== this.lierIndex))) {
                this.currentPoints.push(data);
            }
            if (data.point && explodeSeries && chart.isPointMouseDown) {
                this.currentPoints.push(data);
            }
            if (this.currentPoints.length === 0 && data.point && !explodeSeries && !isNullOrUndefined(previous) &&
                previous.point !== data.point) {
                this.removeHighlightedMarker(previous.series, previous.point);
                this.previousPoints = extend([], data, null, true);
            }
            if (chart.tooltip.showNearestTooltip && this.chart.tooltipModule && this.chart.tooltipModule.currentPoints && (explodeSeries || (series.type === 'Pareto' && series.paretoOptions.marker.visible)) &&
                this.currentPoints.length === 0 && withInBounds(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect)) {
                this.currentPoints = this.chart.tooltipModule.currentPoints;
            }
        }
        else {
            if (!withInBounds(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect)) {
                return null;
            }
            if (chart.tooltip.enable) {
                const pointData = chart.chartAreaType === 'PolarRadar' ? this.getData() : null;
                if (!this.chart.tooltip.showNearestPoint) {
                    this.currentPoints = this.chart.tooltipModule.currentPoints;
                }
                else {
                    for (const chartSeries of chart.visibleSeries) {
                        if (!chartSeries.enableTooltip || chartSeries.category === 'Indicator') {
                            continue;
                        }
                        if (chart.chartAreaType === 'Cartesian' && chartSeries.visible) {
                            data = this.getClosestX(chart, chartSeries, this.commonXValue(this.chart.visibleSeries));
                        }
                        else if (chart.chartAreaType === 'PolarRadar' && chartSeries.visible && pointData.point !== null) {
                            data = new PointData(chartSeries.points[pointData.point.index], chartSeries);
                        }
                        if (data) {
                            this.currentPoints.push(data);
                            data = null;
                        }
                    }
                }
            }
        }
        const length = this.previousPoints.length;
        if (this.currentPoints.length > 0 || (length > 0 && (chart.tooltip.shared || chart.tooltip.split))) {
            if (length === 0 || chart.isPointMouseDown || (length > 0 && (this.currentPoints.length === 0 ||
                (this.previousPoints[0].point !== this.currentPoints[0].point)))) {
                if (length > 0) {
                    for (const previousPoint of this.previousPoints) {
                        if (!isNullOrUndefined(previousPoint)) {
                            this.removeHighlightedMarker(previousPoint.series, previousPoint.point);
                        }
                    }
                }
                for (const data of this.currentPoints) {
                    if ((data && data.point) || ((series.type !== 'Candle') &&
                        (series.type !== 'Hilo') && (series.type !== 'HiloOpenClose'))) {
                        stopTimer(this.markerExplode);
                        this.isRemove = true;
                        data.point.symbolLocations.map((location, index) => {
                            if (data.series.marker.allowHighlight && (!data.series.isRectSeries || data.point.marker.visible)) {
                                this.drawTrackBall(data.series, data.point, location, index);
                            }
                        });
                    }
                }
                this.previousPoints = extend([], this.currentPoints, null, true);
            }
        }
        if (!chart.tooltip.enable && ((this.currentPoints.length === 0 && this.isRemove) || (remove && this.isRemove) ||
            !withInBounds(chart.mouseX, chart.mouseY, chart.chartAxisLayoutPanel.seriesClipRect))) {
            this.isRemove = false;
            if (!isNullOrUndefined(this.previousPoints[0])) {
                this.markerExplode = +setTimeout(() => {
                    if (this.previousPoints[0]) {
                        this.removeHighlightedMarker(this.previousPoints[0].series, this.previousPoints[0].point);
                    }
                }, 2000);
            }
        }
        this.currentPoints = [];
    }
    animationDuration() {
        let duration = 200;
        if (this.chart.maxPointCount > 100) {
            duration = 10;
        }
        else if (this.chart.maxPointCount > 50) {
            duration = 100;
        }
        return duration;
    }
    cloneTrustedElement(source) {
        return source.cloneNode(true);
    }
    renderTrackballDataLabel(series, point) {
        if (!series || !point || !series.marker || !series.marker.dataLabel || !series.marker.dataLabel.visible) {
            return;
        }
        const chartId = this.chart.element.id;
        const seriesIndex = series.index;
        const pointIndex = point.index;
        const root = this.chart.enableCanvas ? document.getElementById(chartId + '_Secondary_Element') : this.chart.svgObject;
        if (!root) {
            return;
        }
        const shapeElements = root.querySelectorAll('[id^="' + chartId + '_Series_' + seriesIndex + '_Point_' + pointIndex + '_TextShape_"]');
        const textElements = root.querySelectorAll('[id^="' + chartId + '_Series_' + seriesIndex + '_Point_' + pointIndex + '_Text_"]');
        if ((!shapeElements || shapeElements.length === 0) && (!textElements || textElements.length === 0)) {
            return;
        }
        const tempGroupId = chartId + '_Series_' + seriesIndex + '_Point_' + pointIndex + '_TrackballDataLabel';
        const tempGroup = this.chart.svgRenderer.createGroup({ id: tempGroupId });
        tempGroup.setAttribute('pointer-events', 'none');
        let sourceParent = null;
        if (shapeElements.length > 0 && shapeElements[0].parentElement) {
            sourceParent = shapeElements[0].parentElement;
        }
        else if (textElements.length > 0 && textElements[0].parentElement) {
            sourceParent = textElements[0].parentElement;
        }
        if (sourceParent instanceof Element) {
            const transform = sourceParent.getAttribute('transform');
            const clipPath = sourceParent.getAttribute('clip-path');
            if (transform) {
                tempGroup.setAttribute('transform', transform);
            }
            if (clipPath) {
                tempGroup.setAttribute('clip-path', clipPath);
            }
        }
        for (let i = 0; i < shapeElements.length; i++) {
            const shapeElement = shapeElements.item(i);
            if (!shapeElement) {
                continue;
            }
            const shapeClone = this.cloneTrustedElement(shapeElement);
            shapeClone.setAttribute('id', shapeElement.id + '_Trackball');
            tempGroup.appendChild(shapeClone);
        }
        for (let j = 0; j < textElements.length; j++) {
            const textElement = textElements.item(j);
            if (!textElement) {
                continue;
            }
            const textClone = this.cloneTrustedElement(textElement);
            textClone.setAttribute('id', textElement.id + '_Trackball');
            tempGroup.appendChild(textClone);
        }
        const target = this.chart.enableCanvas ? document.getElementById(chartId + '_trackball_svg') : this.chart.svgObject;
        if (!target) {
            return;
        }
        target.appendChild(tempGroup);
    }
    drawTrackBall(series, point, location, index) {
        const marker = point.marker;
        const seriesMarker = series.marker;
        const shape = marker.shape || seriesMarker.shape || 'Circle';
        let svg;
        if (shape === 'None' || shape === 'Image') {
            return null;
        }
        const element = series.symbolElement || series.seriesElement;
        let className;
        if (this.chart.highlightModule && this.chart.highlightMode !== 'None') {
            className = this.chart.highlightModule.generateStyle(series);
        }
        if (this.chart.selectionModule && this.chart.selectionMode !== 'None') {
            className = this.chart.selectionModule.generateStyle(series);
        }
        const symbolId = this.elementId + '_Series_' + series.index + '_Point_' + point.index + '_Trackball' +
            (index ? index : '');
        if (getElement(symbolId + '_1') && getElement(symbolId + '_1').getAttribute('e-animate')) {
            Animation.stop(getElement(symbolId + '_1'));
            remove(getElement(symbolId + '_1'));
        }
        const size = new Size((marker.width || seriesMarker.width) + 3, (marker.height || seriesMarker.height) + 3);
        const border = (marker.border || series.border);
        const explodeSeries = (series.type === 'BoxAndWhisker' || series.type === 'Bubble' || series.type === 'Scatter');
        const borderColor = (border.color && border.color !== 'transparent') ? border.color :
            marker.fill || point.interior || (explodeSeries ? point.color : series.interior);
        const colorValue = convertHexToColor(colorNameToHex(borderColor));
        const borderWidth = marker.border ? marker.border.width : seriesMarker.border.width;
        const markerShadow = series.chart.themeStyle.markerShadow ||
            'rgba(' + colorValue.r + ',' + colorValue.g + ',' + colorValue.b + ',0.2)';
        const markerElement = document.getElementById(this.elementId + '_Series_' + series.index + '_Point_' +
            point.index + '_Symbol');
        if (!isNullOrUndefined(markerElement)) {
            markerElement.setAttribute('visibility', 'visible');
        }
        if (this.chart.enableCanvas) {
            const trackElement = document.getElementById(this.chart.element.id + '_Secondary_Element');
            svg = this.chart.svgRenderer.createSvg({
                id: this.chart.element.id + '_trackball_svg',
                width: this.chart.availableSize.width,
                height: this.chart.availableSize.height
            });
            svg.style.cssText = 'position: absolute; display:block; pointer-events: none';
            trackElement.appendChild(svg);
        }
        for (let i = 0; i < 2; i++) {
            const options = new PathOption(symbolId + '_' + i, i ? (marker.fill || point.color || (explodeSeries ? series.interior : '#ffffff')) : 'transparent', borderWidth + (i ? 0 : 8), i ? borderColor : markerShadow, (marker.opacity || seriesMarker.opacity), series.marker.border.dashArray, '');
            const symbol = drawSymbol(location, shape, size, marker.imageUrl, options, '', this.chart.svgRenderer, series.clipRect);
            // incident: 252450 point click selection not working while maker explode
            //symbol.setAttribute('style', 'pointer-events:none');
            symbol.setAttribute('class', this.elementId + '_EJ2-Trackball_Series_' + series.index + '_Point_' + point.index);
            const selectionId = element.id.indexOf('Symbol') !== -1 ? '_Symbol' : '';
            const seletionElem = document.getElementById(this.elementId + '_Series_' + series.index + '_Point_' +
                point.index + selectionId);
            if (className !== '' && !isNullOrUndefined(className) && !isNullOrUndefined(seletionElem) &&
                seletionElem.hasAttribute('class') && (className === seletionElem.getAttribute('class'))) {
                symbol.classList.add(className);
            }
            symbol.setAttribute('clip-path', element.getAttribute('clip-path'));
            symbol.setAttribute('transform', element.getAttribute('transform'));
            if (this.chart.enableCanvas) {
                svg.appendChild(symbol);
            }
            else {
                this.chart.svgObject.appendChild(symbol);
            }
            if (point.symbolLocations.length > 1 && series.marker.visible && (series.type !== 'Bubble' && series.type !== 'Scatter')) {
                this.trackballAnimate(symbol, 0, this.animationDuration(), series, point.index, location, false, false);
            }
        }
        if (series.type === 'Bubble') {
            this.renderTrackballDataLabel(series, point);
        }
        if (point.symbolLocations.length < 2 && series.marker.visible) {
            this.doAnimation(series, point, false);
        }
    }
    /**
     * Perform animation for the series.
     *
     * @param {Series} series - The series to animate.
     * @param {Points} point - The point to animate.
     * @param {boolean} [endAnimate=false] - Flag to indicate if the animation is ending.
     * @returns {void}
     * @private
     */
    doAnimation(series, point, endAnimate = false) {
        if (series.type === 'Bubble' || series.type === 'Scatter') {
            return;
        }
        const duration = this.animationDuration();
        const delay = 0;
        const rectElements = document.getElementsByClassName(this.elementId + '_EJ2-Trackball_Series_' + series.index + '_Point_' + point.index);
        for (let i = 0, len = rectElements.length; i < len; i++) {
            this.trackballAnimate(rectElements[i], delay, duration, series, point.index, point.symbolLocations[0], false, endAnimate);
        }
    }
    /**
     * Perform animation for the trackball.
     *
     * @param {Element} elements - The elements to animate.
     * @param {number} delays - The delay duration for the animation.
     * @param {number} durations - The duration of the animation.
     * @param {Series} series - The series associated with the trackball.
     * @param {number} pointIndex - The index of the point to animate.
     * @param {ChartLocation} point - The location of the point to animate.
     * @param {boolean} isLabel - Flag to indicate if the animated element is a label.
     * @param {boolean} [endAnimate=false] - Flag to indicate if the animation is ending.
     * @param {boolean} [isRemove=false] - Flag to indicate if element need to remove.
     * @returns {void}
     * @private
     */
    trackballAnimate(elements, delays, durations, series, pointIndex, point, isLabel, endAnimate, isRemove) {
        const centerX = point.x;
        const centerY = point.y;
        const clipX = (series.type !== 'Polar' && series.type !== 'Radar') ? series.clipRect.x : 0;
        const clipY = (series.type !== 'Polar' && series.type !== 'Radar') ? series.clipRect.y : 0;
        // let height: number = 0;
        //(<HTMLElement>elements).style.visibility = 'hidden';
        const transform = elements.getAttribute('transform');
        const scaleX = (series.marker.width / (series.marker.width + 3));
        const scaleY = (series.marker.height / (series.marker.height + 3));
        const scaleValue = Math.min(scaleX, scaleY);
        if (!isRemove) {
            elements.setAttribute('transform', `translate(${centerX + clipX} ${centerY + clipY}) scale(${scaleValue}) translate(${-centerX} ${-centerY})`);
        }
        new Animation({}).animate(elements, {
            duration: durations,
            delay: delays,
            progress: (args) => {
                args.element.style.animation = '';
                if (args.timeStamp > args.delay) {
                    if (!series.visible && isRemove) {
                        remove(elements);
                        return;
                    }
                    const progress = args.timeStamp / args.duration;
                    const currentScale = isRemove
                        ? Math.max(scaleValue, 1 - ((1 - scaleValue) * progress))
                        : Math.min(1, scaleValue + ((1 - scaleValue) * progress));
                    elements.setAttribute('transform', `translate(${centerX + clipX} ${centerY + clipY}) scale(${currentScale}) translate(${-centerX} ${-centerY})`);
                }
            },
            end: () => {
                elements.style.visibility = '';
                elements.setAttribute('transform', transform);
                if (!isLabel && (pointIndex === series.points.length - 1)) {
                    series.chart.trigger('animationComplete', { series: series });
                }
                if (isRemove || endAnimate) {
                    remove(elements);
                }
            }
        });
    }
    /**
     * Remove the highlighted marker.
     *
     * @param {Series} [series=null] - The series associated with the marker to remove. Defaults to null.
     * @param {Points} [point=null] - The point associated with the marker to remove. Defaults to null.
     * @param {boolean} [fadeOut=false] - Flag to indicate if the removal should be faded out. Defaults to false.
     * @returns {void}
     * @private
     */
    removeHighlightedMarker(series = null, point = null, fadeOut = false) {
        if (!isNullOrUndefined(series) && !isNullOrUndefined(point)) {
            const tempGroup = document.getElementById(this.chart.element.id + '_Series_' + series.index + '_Point_' + point.index + '_TrackballDataLabel');
            const markerElement = document.getElementById(this.elementId + '_Series_' + series.index + '_Point_' +
                point.index + '_Symbol');
            const trackballElements = document.getElementsByClassName(this.elementId + '_EJ2-Trackball_Series_' + series.index + '_Point_' + point.index);
            if (trackballElements.length === 0) {
                const elements = document.querySelectorAll(`[class*="${this.elementId + '_EJ2-Trackball_Series_' + series.index + '_Point_' + point.index}"]`);
                if (elements[1]) {
                    elements[1].remove();
                }
                if (elements[0]) {
                    elements[0].remove();
                }
            }
            if (tempGroup) {
                tempGroup.remove();
            }
            for (let i = trackballElements.length - 1; i >= 0; i--) {
                if (!series.marker.visible || trackballElements[i] && trackballElements[i].id[trackballElements[i].id.length - 1] === '0' || series.type === 'Scatter' || series.type === 'Bubble') {
                    remove(trackballElements[i]);
                }
            }
            for (let i = trackballElements.length - 1; i >= 0; i--) {
                if (trackballElements[i] && trackballElements[i].id[trackballElements[i].id.length - 1] === '1' && (series.type !== 'Bubble' && series.type !== 'Scatter') && series.marker.visible) {
                    trackballElements[i].setAttribute('opacity', markerElement ? markerElement.getAttribute('opacity') : trackballElements[i].getAttribute('opacity'));
                    this.trackballAnimate(trackballElements[i], 0, this.animationDuration(), series, point.index, point.symbolLocations[i], null, null, true);
                }
            }
            if (!isNullOrUndefined(markerElement)) {
                markerElement.setAttribute('visibility', 'visible');
            }
        }
        else {
            for (const point of series.points) {
                const elements = document.getElementsByClassName(this.elementId + '_EJ2-Trackball_Series_' + series.index + '_Point_' + point.index);
                const markerElement = document.getElementById(this.elementId + '_Series_' + series.index + '_Point_' +
                    point.index + '_Symbol');
                const tempGroup = document.getElementById(this.chart.element.id + '_Series_' + series.index + '_Point_' + point.index + '_TrackballDataLabel');
                if (tempGroup) {
                    tempGroup.remove();
                }
                for (let i = 0, len = elements.length; i < len; i++) {
                    if (!isNullOrUndefined(markerElement)) {
                        markerElement.setAttribute('visibility', 'visible');
                    }
                    remove(elements[0]);
                }
            }
        }
        if (fadeOut) {
            this.previousPoints = [];
        }
    }
}
